



















































import { CrsForm } from '@resclick/crs-ui';
import { IProperty } from '@resclick/data-access';
import { Component, PropSync, Vue } from 'vue-property-decorator';
import TabGeneral from './companies-modal-tabs/general.tab.vue';
import TabPolicies from './companies-modal-tabs/policies-shell.tab.vue';
import TabEmail from './companies-modal-tabs/email.tab.vue';
import TabLogo from './companies-modal-tabs/logo.tab.vue';

@Component({
  components: {
    TabGeneral,
    TabPolicies,
    TabEmail,
    TabLogo,
  },
})
export default class CompaniesModal extends Vue {
  @PropSync('open') openSync!: boolean;
  @PropSync('id', { type: String }) idSync!: string;

  form!: CrsForm<'companies', 'create' | 'update'>;
  currentTab = 'general';

  get mode() {
    return this.idSync ? 'update' : 'create';
  }

  onTabChange(tabName: string) {
    const tab: any = this.$refs[this.currentTab];
    if (tab?.checkUnsaved) tab.checkUnsaved(() => (this.currentTab = tabName));
    else this.currentTab = tabName;
  }

  onUpdateGeneral(data: IProperty) {
    if (data.id) this.idSync = data.id;
  }

  onHide(value: boolean) {
    if (!value) {
      const tab: any = this.$refs[this.currentTab];
      if (tab?.checkUnsaved) {
        tab.checkUnsaved(() => {
          this.currentTab = 'general';
          this.openSync = false;
        });
      } else {
        this.currentTab = 'general';
        this.openSync = false;
      }
    } else this.openSync = true;
  }
}
